<template>
  <div
    class="outline"
    v-for="item in videoData[0]?.examline"
    :key="item.lineID"
  >
    <ul>
      <li>
        <a href="javascript:;" @click="showOutline(item.lineID)"
          >{{ item.lineName }}
        </a>
        <i
          @click="showOutline(item.lineID)"
          style="font-size: 25px"
          class="iconfont icon-youjiantou"
        ></i>
      </li>
    </ul>
  </div>
  <div class="dialog">
    <el-dialog v-model="visible" align-center width="750">
      <div v-for="item in examline" :key="item.lineID" class="header">
        <h3>{{ item.lineName }}</h3>
        <p>作者/来源：{{ item.lineAuthor }}</p>
        <p v-html="item.lineBody"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from "vue";
import { findOutlineView } from "@/api/video";
export default {
  props: {
    videoData: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const visible = ref(false);
    const examline = ref([]);
    const showOutline = (lineID) => {
      visible.value = true;
      findOutlineView(lineID)
        .then((data) => {
          examline.value = data;
        })
        .catch((error) => {
          console.log(error);
        });
    };
    return { showOutline, visible, examline };
  },
};
</script>

<style lang="less" scoped>
.outline {
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      display: flex;
      align-items: center;
      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      & :hover {
        color: @shColor;
        cursor: pointer;
      }

      //background: #dedede;
    }
  }
}
.dialog {
  p {
    margin-top: 15px;
  }
}
</style>
